"use client";

import { ICONS_VARIABLE_NAMES } from "@/common/globalTypes/enums/common";

const UcConnection = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 31 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M6.82955 13.9383C10.6014 13.9383 13.6591 10.8319 13.6591 7C13.6591 3.16809 10.6014 0.0617142 6.82955 0.0617142C3.05769 0.0617142 0 3.16809 
        0 7C0 10.8319 3.05769 13.9383 6.82955 13.9383ZM20.2293 0.0617142H17.4629V7.26348L17.4631 7.3049L17.4629 7.3513C17.4629 10.9892 20.3658 13.9383
         23.9467 13.9383C27.5275 13.9383 30.4304 10.9892 30.4304 7.3513L30.4303 7.30808L30.4304 7.26348V0.0617142H27.664V7.26348H27.663C27.6637 7.29264 
         27.664 7.32197 27.664 7.3513C27.664 9.43701 25.9997 11.1278 23.9467 11.1278C21.8936 11.1278 20.2293 9.43701 20.2293 7.3513C20.2293 7.32197 20.2296 7.29264 20.2303 7.26348H20.2293V0.0617142Z`}
        fill={ICONS_VARIABLE_NAMES.primary}
      />
    </svg>
  );
};

export default UcConnection;
